/**
 * Dealer trust and contact copy (Milestone 11).
 */
import { DEALER_VERIFICATION_STATUS } from "./automapListingConstants";

export const DEALER_VERIFICATION_LABELS_ES = {
  [DEALER_VERIFICATION_STATUS.VERIFIED]: "Concesionario verificado",
  [DEALER_VERIFICATION_STATUS.PENDING]: "Verificación pendiente",
  [DEALER_VERIFICATION_STATUS.UNVERIFIED]: "Concesionario no verificado",
  [DEALER_VERIFICATION_STATUS.REJECTED]: "No disponible",
  [DEALER_VERIFICATION_STATUS.UNKNOWN]: "Verificación no disponible",
};

export const DEALER_VERIFICATION_DESCRIPTIONS_ES = {
  [DEALER_VERIFICATION_STATUS.VERIFIED]:
    "AutoMapa revisó información básica del concesionario.",
  [DEALER_VERIFICATION_STATUS.PENDING]:
    "Este concesionario está en proceso de verificación en AutoMapa.",
  [DEALER_VERIFICATION_STATUS.UNVERIFIED]:
    "AutoMapa aún no ha completado la verificación de este vendedor.",
  [DEALER_VERIFICATION_STATUS.REJECTED]:
    "Este concesionario no está disponible en AutoMapa.",
  [DEALER_VERIFICATION_STATUS.UNKNOWN]:
    "No tenemos información de verificación para este concesionario.",
};

export const CONTACT_DISABLED_REASONS = {
  LISTING_UNAVAILABLE: "listing_unavailable",
  DEALER_CONTACT_MISSING: "dealer_contact_missing",
  DEALER_INACTIVE: "dealer_inactive",
  DEALER_SUSPENDED: "dealer_suspended",
  LISTING_NOT_PUBLIC: "listing_not_public",
  UNKNOWN: "unknown",
};

export const CONTACT_DISABLED_LABELS_ES = {
  listing_unavailable: "Este vehículo ya no está disponible.",
  dealer_contact_missing: "Contacto por confirmar.",
  dealer_inactive: "Este concesionario no está disponible en este momento.",
  dealer_suspended: "Este concesionario no está disponible en este momento.",
  listing_not_public: "Contacto no disponible.",
  no_whatsapp: "Contacto no disponible.",
  dealer_unavailable: "Este concesionario no está disponible en este momento.",
  unknown: "Contacto no disponible.",
};

export const DEALER_TRUST_NOTES_ES = {
  default:
    "Antes de visitar o separar un vehículo, confirma disponibilidad, precio, documentos y condiciones directamente con el concesionario.",
  verified:
    "AutoMapa revisó información básica del concesionario. Aun así, confirma documentos y estado del vehículo antes de comprar.",
  unverified:
    "Confirma datos del concesionario, dirección y documentos antes de separar el vehículo.",
};

export const DEALER_CONTACT_COPY_ES = {
  dealerLabel: "Concesionario",
  contactWhatsapp: "Contactar por WhatsApp",
  callDealer: "Llamar",
  viewProfile: "Ver perfil del concesionario",
  browseDirectory: "Ver más concesionarios en AutoMapa",
  contactUnavailable: "Contacto no disponible",
  mobileContact: "Contactar por WhatsApp",
};

export const DEALER_CONTACT_ANALYTICS_EVENTS = {
  BADGE_VIEWED: "dealer_badge_viewed",
  PROFILE_CLICKED: "dealer_profile_clicked",
  CONTACT_CTA_CLICKED: "vehicle_contact_cta_clicked",
  WHATSAPP_CLICKED: "vehicle_whatsapp_clicked",
  PHONE_CLICKED: "vehicle_phone_clicked",
  LEAD_CREATED: "vehicle_lead_created",
  LEAD_CREATE_FAILED: "vehicle_lead_create_failed",
  CONTACT_DISABLED_CLICKED: "vehicle_contact_disabled_clicked",
  WHATSAPP_OPENED: "vehicle_contact_whatsapp_opened",
};

/** Lightweight lead duplicate window (ms). */
export const LEAD_DUPLICATE_WINDOW_MS = 30_000;
